export default "__VITE_ASSET__7rfYU5fg__"